// frontend/src/utils/fileDisplay.js
// Helpers para representar archivos adjuntos en UI (ícono por tipo, tamaño legible).

export function iconForContentType(contentType) {
  if (!contentType) return 'bi bi-file-earmark';
  if (contentType.includes('pdf')) return 'bi bi-file-earmark-pdf';
  if (contentType.includes('image')) return 'bi bi-file-earmark-image';
  if (contentType.includes('word') || contentType.includes('document')) return 'bi bi-file-earmark-word';
  if (contentType.includes('sheet') || contentType.includes('excel')) return 'bi bi-file-earmark-spreadsheet';
  return 'bi bi-file-earmark';
}

export function formatFileSize(bytes) {
  if (!bytes || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
